import { render } from "./RegisterStep4.vue?vue&type=template&id=e80732e0&scoped=true"
import script from "./RegisterStep4.vue?vue&type=script&lang=js"
export * from "./RegisterStep4.vue?vue&type=script&lang=js"

import "./RegisterStep4.vue?vue&type=style&index=0&id=e80732e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80732e0"]])

export default __exports__